import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  init() {
    console.log('news');

    new Swiper('.swiperNews', {
        modules: [Navigation],
        slideToClickedSlide: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        loop: true,
    });

    jQuery(document).ready(function ($) {


        let newsContainer = $('#newsContainer');
        let loadingContainer = $('#loadingContainer');
        let loadMoreBtn = $('#loadMoreNews');
        let paged = 1;


        loadMoreBtn.bind('click', function (e) {
            e.preventDefault();
            paged++;
            loadNews();
        });

        function loadNews() {
            loadingContainer.addClass('loading');

            $.ajax({
                type: 'POST',
                url: '/2025/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    action: 'news_filter',
                    paged: paged,
                },
                success: function (res) {
                    console.log(res)
                    if (res.posts) {
                        if (paged == 1) {
                            newsContainer.html(res.posts);
                        } 
                        else {
                            newsContainer.append(res.posts);
                        }
                        
                        if (res.maxPages > paged && loadMoreBtn.length) {
                            loadMoreBtn.show();
                        } 
                        else {
                            loadMoreBtn.hide();
                        }
                    }

                    if (res.posts.length == 0) {
                        newsContainer.html('');
                        loadMoreBtn.hide();
                    }
                    loadingContainer.removeClass('loading');
                },
                fail: function (err) {
                    console.log('There was an error: ' + err);
                    loadingContainer.removeClass('loading');
                },
            });
        }

    });

    

  },
  finalize() {
    
  },
};
